import { IconButton, styled } from '../../../base-components';

export const StyledTableHeaderCell = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    paddingInlineStart: theme.spacing(2),
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
    marginInlineStart: theme.spacing(0.5),
    padding: theme.spacing(0.2),
    '.MuiTouchRipple-root': {
        borderRadius: '50%',
    },
}));
